/*--------------------------------------------------------
 * Author Trần Đức Tiến
 * Email ductienas@gmail.com
 * Phone 0972970075
 * Created: 2017-05-27 12:56:17
 *
 * LastModified: 2017-06-01 17:12:42
 *-------------------------------------------------------*/

import { take, call, put, fork, all } from 'redux-saga/effects';
import fetchApi from '../../../../../utils/fetchApi';

function* getAllGlassesFlow() {
  const INFINITE = true;

  while (INFINITE) {
    const { payload: { filter, clearState, sortBy = 'latest' }, next } = yield take('GET_ALL_GLASSES');
    if (clearState) {
      yield put({ type: 'RESET_ALL_GLASSES_STATE' });
    }
    try {
      const response = yield call(fetchApi, `Products/search?filter=${JSON.stringify(filter)}&sortBy=${sortBy}`);
      if (response && !response.error) {
        yield put({ type: 'GET_ALL_GLASSES_SUCCESS', payload: response });
        if (next && typeof next === 'function') {
          next();
        }
      }
    } catch (err) {
      yield put({ type: 'REQUEST_ERROR', payload: err });
    }
  }
}

function* getAllGlassesFilterByLocaleFlow() {
  const INFINITE = true;

  while (INFINITE) {
    const { payload: { filter, clearState }, next } = yield take('GET_ALL_GLASSES_FILTER_BY_LOCALE');
    if (clearState) {
      yield put({ type: 'RESET_ALL_GLASSES_STATE' });
    }
    try {
      const response = yield call(fetchApi, `Products/getProductListFilterByLocale?filter=${JSON.stringify(filter)}`);
      if (response && !response.error) {
        yield put({ type: 'GET_ALL_GLASSES_SUCCESS', payload: response });
        if (next && typeof next === 'function') {
          next();
        }
      }
    } catch (err) {
      yield put({ type: 'REQUEST_ERROR', payload: err });
    }
  }
}

function* exportAllGlassesFlow() {
  const INFINITE = true;

  while (INFINITE) {
    const { payload: { filter, sortBy = 'latest' }, next } = yield take('EXPORT_ALL_GLASSES');
    try {
      const response = yield call(fetchApi, `Products/search?filter=${JSON.stringify(filter)}&sortBy=${sortBy}`);
      if (response && !response.error) {
        if (next && typeof next === 'function') {
          next(response);
        }
      }
    } catch (err) {
      yield put({ type: 'REQUEST_ERROR', payload: err });
    }
  }
}

function* updateAllGlassesFlow() {
  const INFINITE = true;

  while (INFINITE) {
    const { payload, next } = yield take('UPDATE_ALL_GLASSES');
    try {
      const reqs = [];
      payload.forEach(el => {
        const data = el;
        const productId = data.id;
        delete data.id;
        reqs.push(call(fetchApi, `Products/${productId}`, data, { method: 'PATCH' }));
      });

      const responses = yield all(reqs);
      if (responses && responses[0] && !responses[0].error) {
        if (next && typeof next === 'function') {
          next();
        }
      }
    } catch (err) {
      yield put({ type: 'REQUEST_ERROR', payload: err });
    }
  }
}

function* updateLocaleInformationFlow() {
  const INFINITE = true;

  while (INFINITE) {
    const { payload, next } = yield take('UPDATE_LOCALE_INFORMATION');

    const productId = payload.productId;
    const productLocaleId = payload.productLocaleId;

    const data = {
      localeId: payload.localeId,
      price: payload.price,
      url: payload.url,
      note: payload.note
    };

    try {
      const response = yield call(fetchApi, `Products/${productId}/locales/${productLocaleId}`, data, { method: 'PUT' });

      if (response && !response.error) {
        if (next && typeof next === 'function') {
          next();
        }
      }
    } catch (err) {
      yield put({ type: 'REQUEST_ERROR', payload: err });
    }
  }
}

function* deleteAllGlassesFlow() {
  const INFINITE = true;

  while (INFINITE) {
    const { payload, next } = yield take('DELETE_ALL_GLASSES');
    try {
      const reqs = [];
      payload.filter(el => {
        // Delete document in database
        reqs.push(call(fetchApi, `Products/${el.id}`, {}, { method: 'DELETE' }));
      });

      const responses = yield all(reqs);
      if (responses && responses[0] && !responses[0].error) {
        if (next && typeof next === 'function') {
          next();
        }
      }
    } catch (err) {
      yield put({ type: 'REQUEST_ERROR', payload: err });
    }
  }
}

function* addMultiGlassesFlow() {
  const INFINITE = true;

  while (INFINITE) {
    const { payload: { importData, locales, brands }, next } = yield take('ADD_MULTI_GLASSES');

    const finalData = importData.slice(1, importData.length);

    try {
      const createProductReqs = [];
      finalData.forEach(el => {
        let brandId = '';
        if (Array.isArray(brands)) {
          brands.forEach(brandItem => {
            if (brandItem.name === el[6]) {
              brandId = brandItem.id;
            }
          });
        }
        const data = {
          sku: el[0] ? el[0] : 'unnamed',
          gender: el[1] ? el[1] : 'unisex',
          glassesType: el[2] ? el[2] : 'eyeglasses',
          frameShape: el[3] ? el[3] : 'square',
          frameType: el[4] ? el[4] : 'full_frame',
          material: el[5] ? el[5] : 'metal',
          brandId,
          publicMode: false,
          globalFlg: false,
          size: {
            lensWidth: el[7] ? parseInt(el[7]) : 52,
            bridge: el[8] ? parseInt(el[8]) : 18,
            temple: el[9] ? parseInt(el[9]) : 140,
            lensHeight: el[10] ? parseInt(el[10]) : 25
          }
        };
        createProductReqs.push(call(fetchApi, 'Products', data, { method: 'POST' }));
      });

      const products = yield all(createProductReqs);

      if (products && products[0] && !products[0].error) {
        const createLocaleModelReqs = [];
        products.forEach((el, index) => {
          let i = 11;
          while (finalData[index][i] || finalData[index][i + 1] || finalData[index][i + 2] || finalData[index][i + 3] ||
            finalData[index][i + 4] || finalData[index][i + 5]) {
            let localeId = '';
            if (Array.isArray(locales)) {
              locales.forEach(localeItem => {
                if (localeItem.country === finalData[index][i] ||
                  localeItem.lang === finalData[index][i + 1] ||
                  localeItem.currency === finalData[index][i + 2]) {
                  localeId = localeItem.id;
                }
              });
            }
            const localeData = {
              localeId,
              price: finalData[index][i + 3],
              url: finalData[index][i + 4],
              note: finalData[index][i + 5]
            };
            createLocaleModelReqs.push(call(fetchApi, `Products/${el.id}/locales`, localeData, { method: 'POST' }));

            i += 6;
          }
          createLocaleModelReqs.push(
            call(fetchApi, `Products/${el.id}/models`, { zipUrl: '', photos: '', color: JSON.stringify({ r: '255', g: '255', b: '255', a: '0.22' }) }, { method: 'POST' })
          );
        });

        const productLocaleModels = yield all(createLocaleModelReqs);

        if (productLocaleModels && productLocaleModels[0] && !productLocaleModels[0].error) {
          if (next && typeof next === 'function') {
            next();
          }
        }
      }
    } catch (err) {
      yield put({ type: 'REQUEST_ERROR', payload: err });
    }
  }
}

function* getTotalDownloadCountFlow() {
  const INFINITE = true;

  while (INFINITE) {
    yield take('GET_TOTAL_DOWNLOAD_COUNT');
    try {
      const response = yield call(fetchApi, 'Products/getTotalDownloadCount');
      if (response && !response.error) {
        yield put({ type: 'GET_TOTAL_DOWNLOAD_COUNT_SUCCESS', payload: response });
      }
    } catch (err) {
      yield put({ type: 'REQUEST_ERROR', payload: err });
    }
  }
}

export default function* glassesFlow() {
  yield fork(getAllGlassesFlow);
  yield fork(getAllGlassesFilterByLocaleFlow);
  yield fork(exportAllGlassesFlow);
  yield fork(updateAllGlassesFlow);
  yield fork(deleteAllGlassesFlow);
  yield fork(updateLocaleInformationFlow);
  yield fork(addMultiGlassesFlow);
  yield fork(getTotalDownloadCountFlow);
}



// WEBPACK FOOTER //
// ./routes/app/routes/glasses-list/saga/index.js